export const PASSWORD_SUBMITTED = 'PASSWORD_SUBMITTED';

export const passwordSubmitted = () => dispatch =>
  dispatch({
    type: PASSWORD_SUBMITTED,
  });
